/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Editar",
  "i18n.actionBar.removeImage": "Remover",
  "i18n.actionBar.swapImage": "Intercambiar",
  "i18n.additionalInfoItemLayers.smartSorted.new": "¡Nuevo!",
  "i18n.additionalProducts.addToCart": "Agregar a la orden",
  "i18n.additionalProducts.frame.description": "Marco de aluminio de alta calidad: plata mate, cristal auténtico de primera calidad, sin necesidad de pegamento",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Consejo:",
  "i18n.additionalProducts.frame.subtitle": "El puzzle terminado es un magnifico recuerdo – con nuestro <b>marco</b> luce simplemente perfecto.",
  "i18n.additionalProducts.frame2023.description": "Marco de fibra de madera de alta calidad: fácil de montar, sin cristal, incluye pegamento para puzzle",
  "i18n.additionalProducts.framePlastic.description": "Marco de aluminio de alta calidad: plata mate, vidrio sintético antirreflectante, sin necesidad de pegamento",
  "i18n.additionalProducts.glue.description": "Para hasta dos puzzles de 1000 piezas, incluye esponja aplicadora",
  "i18n.additionalProducts.glue.hook": "Para que tu puzzle se convierta en un cuadro.\nPega y protege de forma duradera.",
  "i18n.additionalProducts.roll.description": "Para puzzles de 48 hasta 2000 piezas",
  "i18n.additionalProducts.roll.hook": "¿No tienes mesa libre? No hay problema.\nEnrolla el puzzle, guárdalo y continúa más tarde.",
  "i18n.adventCalendarOverlay.activate": "Mostrar vista previa de las 24 ventanitas",
  "i18n.adventCalendarOverlay.deactivate": "Ocultar vista previa de las 24 ventanitas",
  "i18n.adventCalendarOverlay.notice": "(Los números y las líneas no se imprimen)",
  "i18n.button.addToCart": "Añadir a la cesta",
  "i18n.button.apply": "Aplicar",
  "i18n.button.back": "Regresar",
  "i18n.button.cancel": "Cancelar",
  "i18n.button.cancelAndFix": "Cambiar ahora",
  "i18n.button.chooseSmartSorted": "Actualizar a SMART SORTED ",
  "i18n.button.close": "Cerrar",
  "i18n.button.continue": "Continuar",
  "i18n.button.createNewTextPlaceholders": "Ingresa texto ",
  "i18n.button.ignore": "Ignorar",
  "i18n.button.ignoreAndContinue": "Continuar de todos modos",
  "i18n.button.mobile.createNewTextPlaceholders": "Texto",
  "i18n.button.noChanges": "No gracias, cerrar ventana",
  "i18n.button.ok": "De acuerdo",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Procesar de nuevo",
  "i18n.button.uploadPhotos": "Subir foto (s)",
  "i18n.button.withSmartSorted": "Actualizar a SMART SORTED ",
  "i18n.button.withoutSmartSorted": "No gracias, cerrar ventana",
  "i18n.control.colorChooser.color": "Color",
  "i18n.control.fontChooser.placeholderText": "Fuente",
  "i18n.control.imageQuality.checkImages": "Revisar resolución de la foto",
  "i18n.control.imageQuality.imageSuitability": "Calidad de la foto:",
  "i18n.control.imageQuality.indicatorAltText": "Calidad de la foto",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Elegir diseño",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Para una mejor legibilidad, por favor acorta la longitud del texto / línea",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "La fuente seleccionada es demasiado grande para este texto.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "El tamaño máximo posible de la fuente para este texto se ha sobrepasado.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "El tamaño mínimo posible de la fuente para este texto se ha sobrepasado.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Por favor, inserta un salto de línea",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Continúa escribiendo en una segunda línea, o amplía el cuadro de texto.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Por favor, comprueba tu texto, esta fuente no es compatible con todos los caracteres.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Se ha alcanzado el número máximo de caracteres",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Para una mejor legibilidad, por favor acorta la longitud del texto / línea.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Por favor amplía el cuadro de texto",
  "i18n.dialog.deletePlaceholder.message": "Este paso no se puede desactualizar",
  "i18n.dialog.deletePlaceholder.title": "¿Eliminar realmente el marcador de posición?",
  "i18n.dialog.error.title": [
    "Se ha producido un error",
    "Se han producido errores"
  ],
  "i18n.dialog.insufficientImageQuality.message": "¡La resolución de esta imagen es demasiado baja para imprimirla de manera óptima!",
  "i18n.dialog.smartSorted.message": "Con SMART SORTED puedes resolver tu imagen con 1000 piezas de forma innovadora y sin esfuerto, incluso sin muestra de la imagen",
  "i18n.dialog.smartSorted.title": "Puzzle - Sensación de éxito garantizada",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Por favor, haz clic en \"{{text}}\" para cambiar el título de la caja.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "El título de la caja no ha sido cambiado.",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuar sin título en la caja.",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Por favor, inserta una foto haciendo clic en el marcador de posición.",
    "Por favor, inserta fotos haciendo clic en el marcador de posición."
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Un marcador de posición está todavía vacío.",
    "Algunos marcadores de posición están todavía vacíos."
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un marcador de posición no ha sido cambiado.",
    "Algunos marcadores de posición no han sido cambiados."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Por favor haz click en la foto y en los marcadores de texto para cambiar tu collage.",
    "Por favor haz click en la foto y en los marcadores de texto para cambiar tu collage."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Algunos marcadores de posición no han sido cambiados",
    "Algunos marcadores de posición no han sido cambiados"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Por favor, haz clic en el marcador de posición de texto para cambiar tu texto",
    "Por favor, haz clic en el marcador de posición de texto para cambiar tus textos"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Un texto del marcador de posición no ha sido cambiado.",
    "Algunos textos de los marcadores de posición no han sido cambiados."
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Marcadores de posición sin cambios.",
  "i18n.error.additionalInfoItemsError.message": "Error de carga de la capa de información",
  "i18n.error.additionalInfoItemsError.title": "Error de carga ",
  "i18n.error.deprecatedBrowserError.message": "El navegador que estás utilizando ya no es compatible, por favor actualízalo a una versión más reciente.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Interrumpiste el diseño durante mucho tiempo. No se puede continuar. Por favor, inicia el proceso nuevamente.",
  "i18n.error.designerExpiredError.title": "Diseño terminado",
  "i18n.error.fontLoadingError.message": "No se pudo cargar una fuente",
  "i18n.error.fontLoadingError.title": "Error de carga",
  "i18n.error.imageLoadingError.message": "Una foto no pudo ser cargada. Ésta fue retirada del área de diseño y galería.",
  "i18n.error.imageLoadingError.title": "Error de descarga.",
  "i18n.error.imageProvisionError.message": "Una o más fotos no pudieron ser procesadas. El tipo de medio probablemente no sea compatible.",
  "i18n.error.imageProvisionError.title": "Una foto no pudo ser procesada.",
  "i18n.error.imageSelectionError.message": "Archivo \"{{reference1}}\" no pudo ser procesada.",
  "i18n.error.imageSelectionError.title": "Error al subir la foto.",
  "i18n.error.imageSizeLimitExceededError.message": "La imagen que subiste es demasiado grande.\nPor favor, reduce el tamaño del archivo por debajo de 180 megapíxeles y cárgalo de nuevo.",
  "i18n.error.imageSizeLimitExceededError.title": "Error al subir la foto.",
  "i18n.error.imageUploadError.message": "Se produjo un problema de conexión a internet. Por favor inténtalo de nuevo más tarde.",
  "i18n.error.imageUploadError.title": "Error al subir la foto.",
  "i18n.error.inlineSVGLoadingError.message": "El marco de tolerancia \"{{reference1}}\" no pudo ser cargado.",
  "i18n.error.inlineSVGLoadingError.title": "Error de descarga.",
  "i18n.error.invalidCharConfigError.message": "Esta fuente no es aplicable, por favor selecciona otra fuente.",
  "i18n.error.invalidCharConfigError.title": "Fuente no aplicable",
  "i18n.error.malformedProductError.message": "Uno o más productos no se pudieron transferir al servidor. Quizás el producto ya no está disponible o el diseño del producto tardó demasiado. Lo sentimos, por favor comienza el diseño nuevamente.",
  "i18n.error.malformedProductError.title": "Error de carga",
  "i18n.error.notInStockError.message": "Lo sentimos, el producto que has seleccionado no está disponible en este momento.\nPuedes ir a la página de inicio a través de nuestro logotipo en la parte superior izquierda. Allí puedes seleccionar un producto diferente.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Tu conexión a internet parece haber sido interrumpida. Puedes continuar diseñando tu producto tan pronto como tu conexión haya sido restaurada.",
  "i18n.error.templateLoadingError.message": "Plantilla \"{{ error.reference[0] }}\" no pudo ser cargada. Por favor inténtelo más tarde.",
  "i18n.error.templateLoadingError.title": "Error de descarga.",
  "i18n.error.transformationError.message": "La transformación no se pudo aplicar ",
  "i18n.error.transformationError.title": "Error de transformación",
  "i18n.error.traudlLoadingError.message": "Por favor, inténtalo de nuevo o utiliza otra imagen.",
  "i18n.error.traudlLoadingError.title": "No se ha podido aplicar el filtro de IA.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" tiene un tipo de medio no compatible.",
  "i18n.error.unsupportedMediaTypeError.title": "Error al subir la foto.",
  "i18n.error.uploadProductError.message": "Uno o más productos no pudieron ser transferidos al servidor. Por favor, inténtalo de nuevo más tarde.",
  "i18n.error.uploadProductError.title": "Error de transferencia",
  "i18n.error.zoomModeError.message": "El texto de tu diseño anterior no pudo ser aceptado, por favor ingresa un nuevo texto.",
  "i18n.error.zoomModeError.title": "Texto no adoptado",
  "i18n.gallery.uploadPhotos.info": "Haz clic en el botón \"Subir foto (s)\"",
  "i18n.gallery.uploadProgress": [
    "Cargando foto ...",
    "Fotos subidas: {{current}} de {{total}}"
  ],
  "i18n.price.price": "Precio",
  "i18n.price.reduction": "Tu ahorras ",
  "i18n.price.total": "Precio total",
  "i18n.priceDisplay.times": [
    "{{value}} pieza a {{pricePerUnit}} cada uno",
    "{{value}} piezas a {{pricePerUnit}} cada uno"
  ],
  "i18n.progress.stepAdditionalProducts": "Accesorios (opcional)",
  "i18n.progressOverlay.message.lines.one": "Gracias por tu creación esmeradamente diseñada.",
  "i18n.progressOverlay.message.lines.two": "Estamos preparando el siguiente paso para ti...",
  "i18n.template.insertText": "Ingresa un texto aquí",
  "i18n.toolbox.gallery.title": "Seleccionar fotos",
  "i18n.toolbox.image.title": "Editar foto",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} fotos"
  ],
  "i18n.toolbox.layout.title": "Cambia el diseño.",
  "i18n.toolbox.layout.triggerText": "Diseño.",
  "i18n.toolbox.preview.title": "Vista previa 3D",
  "i18n.toolbox.productChooser.title": "Cambia producto",
  "i18n.toolbox.productChooser.triggerText": "Producto",
  "i18n.toolbox.text.title": "Editar texto"
};


export class LocaleEsES {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
